import React, { memo } from 'react';
import Grid from '@mui/material/Grid';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import './Product.css';
import Skeletons from '../Skeleton/Skeletons';
import CarouselItem from './CarouselItem';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getOrgName } from '../../utils/appendOrgQuery';
import { Colors } from '../../theme/Theme';

const Product = ({
  title,
  dataRender,
  loading,
  isEditable,
  isUserProfileInProduct,
  domainData,
  getCourses,
  courses,
  accessCourses,
  disableHover,
  showDescription,
  containerHeight,
  forSuggestedOrgPopup,
}) => {
  const orgName = getOrgName();
  const responsive = {
    desktop: {
      breakpoint: { max: 6000, min: 1024 },
      items: 4,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const navigate = useNavigate();

  return (
    <>
      <Grid
        sx={{
          overflow: 'scroll',
          backgroundColor: 'transparent',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontFamily: 'Roboto',
            fontWeight: '500',
            letterSpacing: '0.01em',
            display: '-webkit-box!important',
            WebkitBoxOrient: ' vertical',
            mb: 3,
            position: 'sticky',
            left: 0,
            zIndex: 1,
          }}
        >
          {title}
        </Typography>
        <Carousel
          swipeable={true}
          draggable={true}
          responsive={responsive}
          ssr={true}
          keyBoardControl={true}
          partialVisible={false}
          removeArrowOnDeviceType={['mobile']}
          containerClass="carousel-container"
          itemClass="carousel-item"     
        >
          {loading ? (
            <Box sx={{ display: 'flex' }} className="mainSkeletonContainer">
              <Skeletons type="feed1" />
            </Box>
          ) : dataRender?.length > 0 ? (
            <div style={{flexShrink: 0, display: 'flex', alignItems: 'center', gap: '12px', width: '100%'}} >
              {
                dataRender?.map((item, index) => {
                  return (
                        <CarouselItem
                          forSuggestedOrgPopup={forSuggestedOrgPopup}
                          ProductDetails={item}
                          key={item?.id || index}
                          category={item.categories ? item.categories.split(',') : []}
                          techStack={item.techStack ? item.techStack.split(',') : []}
                          keyfrombackend={item?.id}
                          loading={loading}
                          isEditable={isEditable}
                          isUserProfileInProduct={isUserProfileInProduct}
                          draggable={false}
                          domainData={domainData}
                          getCourses={getCourses}
                          title={title}
                          disableHover={disableHover}
                          showDescription={showDescription}
                          containerHeight={containerHeight}
                          />
                  );
                })
              }
            </div>
          ) : (
            <>
              {isUserProfileInProduct ? (
                <>
                  {courses?.length === 0 ? (
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="row"
                      sx={{ p: 4, justifyItems: 'center' }}
                    >
                      <Box>
                        <Typography
                          sx={{
                            m: 'auto',
                            fontWeight: '200',
                            fontSize: '13px',
                          }}
                          paragraph
                        >
                          No Courses, you can create your course from
                        </Typography>
                      </Box>
                      <Box>
                        <Button
                          size="small"
                          onClick={() => {
                            navigate(`/org/${orgName}/course/create`);
                          }}
                        >
                          Create Course
                        </Button>
                      </Box>
                    </Box>
                  ) : (
                    <></>
                  )}
                  {accessCourses?.length === 0 ? (
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="row"
                      sx={{ p: 4, justifyItems: 'center' }}
                    >
                      <Box>
                        <Typography
                          sx={{
                            m: 'auto',
                            fontWeight: '200',
                            fontSize: '13px',
                            backgroundColor: 'rgb(244,246,255)',
                          }}
                          paragraph
                        >
                          Currently, no Courses are available.
                        </Typography>
                      </Box>
                    </Box>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flexDirection="row"
                  sx={{ p: 4, justifyItems: 'center' }}
                >
                  <Box>
                    <Typography
                      sx={{
                        m: 'auto',
                        fontWeight: '200',
                        fontSize: '13px',
                        color: Colors.paragraphColor || '#666',
                      }}
                      paragraph
                    >
                      No Courses to show here.
                    </Typography>
                  </Box>
                </Box>
              )}
            </>
          )}
        </Carousel>
      </Grid>
    </>
  );
};

export default memo(Product);
